import { WEB_API_ROUTES } from 'api/api-routes';
import { apiWrapper } from '../../api/apiWrapper';
import { createThunk } from '../../utils/storeUtils';

export const thunks = {
  getRoutinesList: createThunk('routines/getRoutinesList', () =>
    apiWrapper.get(WEB_API_ROUTES.routines.list)
  ),
};
